import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

interface LoadingOverlayProps {
  message?: string;
  open?: boolean;
}

export const LoadingOverlay = ({
  message,
  open = true,
}: LoadingOverlayProps) => {
  return (
    <Backdrop
      sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
      open={open}
    >
      <div style={{ textAlign: 'center' }}>
        <CircularProgress color="inherit" />
        {message && (
          <p style={{ marginTop: '1rem', color: '#fff' }}>{message}</p>
        )}
      </div>
    </Backdrop>
  );
};
